import { datadogRum } from "@datadog/browser-rum";
import "@fortawesome/fontawesome-free/css/all.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.js";
import "jquery/dist/jquery";
import React from "react";
import ReactDOM from "react-dom";
import "react-rangeslider/lib/index.css";
import App from "./App";
import WrapperProvider from "./contexts/WrapperProvider";
import "./index.css";
import "./styles/React-Data-Grid-Overrides.css";

if (process.env.REACT_APP_ENV !== "local") {
  datadogRum.init({
    applicationId: process.env.DATADOG_APP_ID,
    clientToken: process.env.DATADOG_CLIENT_TOKEN,
    site: "us5.datadoghq.com",
    service: "best---zone-eval-(old-react)-application",
    env: process.env.REACT_APP_ENV,
    version: process.env.VERSION || "unknown",
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: "mask-user-input",
    allowedTracingUrls: [process.env.REACT_APP_SERVICES_URL],
    beforeSend: event => {
      if (event.type === "resource") {
        if (event.resource.url.match(/\.(m3u8|ts|mp4|webm)/)) {
          event.context.resourceCategory = "video";
        }
      }
      return true;
    }
  });

  datadogRum.setGlobalContextProperty("app", "best-umpire-umpeval");
  datadogRum.setGlobalContextProperty("team", "best-umpire");

  datadogRum.startSessionReplayRecording();
}

ReactDOM.render(
  <WrapperProvider>
    <App />
  </WrapperProvider>,
  document.getElementById("ze-react-app")
);
